import { useContext, useEffect } from 'react';

/**
 * @description Components
 */
import { withRouter } from 'react-router-dom';

/**
 * @description Styles and assets
 */
import classes from './Home.module.css';
import { StoreContext } from '../../stores';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

function Home() {
  const { uiStore } = useContext(StoreContext),
    { t } = useTranslation(),
    clicDataUrl = 'https://brandanalytic.clicdata.com/v/acces-v3';

  useEffect(() => {
    uiStore.setTitle(t('Dashboard access'));
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.container}>
      <iframe title='Clicdata' className={classes.iframe} src={clicDataUrl} />
    </div>
  );
}

export default withRouter(Home);
